/**
 * api接口-共用的
 */
import { post } from '@/request/http'
// 查找一级目录的导航栏
export const apiFindLevelOne = p => post('/navigation/findLevelOne', p)
// 查找二级目录的导航栏
export const apiFindLevelTwo = p => post('/navigation/findLevelTwo', p)
